import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
    dsn: "https://d0a964e3b3e24f17b771dd29ab0622d0@o923914.ingest.sentry.io/5880359",
    integrations: [new Integrations.BrowserTracing()],
    // log 100% on staging
    tracesSampleRate: window.location.host == 'ako.ac.nz' ? 0.1 : 1,
    autoSessionTracking: true,
    environment: window.location.host == 'ako.ac.nz' ? 'live' : 'staging',
    // Ignore errors is checked first, ignore here if error is specific enough
    // This does NOT check the stack, only the exception type/value
    ignoreErrors: [
        'privateSpecialRepair is not defined'
    ],
});

import slick from './slick';
import bindLoadMoreButton from './SeeMore';

// Search
import search from './search/search';
import knowledgeCentreSearch from './search/knowledgeCentreSearch';
import knowledgeDropSearch from './search/knowledgeDropSearch';
import dropSearch from './search/dropSearch';
import filteredLandingHolderFilters from './search/filteredLandingHolderFilters';
import eventHolderFilters from './search/eventHolderFilters';
import searchInteractions from './search/searchInteractions';

import contrast from './contrast';
import navigationToggle from './navigationToggle';
import headerSizeChange from './headerSizeChange';
import slickSlider from './slickSlider';
import tabbedContent from './tabbedContent';
import tallyCounter from './tallyCounter';
import circleAnimation from './circleAnimation';
import footerScrollTop from './footerScrollTop';
import publicationToggle from './publicationToggle';
import smoothScroll from './smoothScroll';
import accordion from './accordion';
import aprilFools from './aprilFools';

window.dataLayer = window.dataLayer || [];



// WEBPACK FOOTER //
// ./src/js/app.js